<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb" :padding="6"></top-navbar>

        <div class="container-fluid mt--6 text-center">

            <div class="card text-left">

                <div class="card-header">
                    <h3 class="mb-0 text-uppercase">Vos données personelles dans SOCRATES</h3>
                </div>

                <div class="card-body">
                    <p>
                        <i>La collecte de vos données personnelles imposée par l’utilisation de SOCRATES forme un traitement de données à caractère personnel géré par l’Ecole Nationale de l’Aviation Civile.</i>
                    </p>

                    <h3>Finalités du traitement de données</h3>
                    <p>
                        Le traitement des données dans la cadre du "Suivi Formation Pratique au contrôle" a pour objectif :
                    </p>
                    <ul>
                        <li>de suivre la performance élève lors de la phase de progression en formation pratique au contrôle</li>
                        <li>de dialoguer entre les élèves, les instructeurs, l’inspecteur des études et les responsables de degrés de formation pratique</li>
                    </ul>
                    <p>
                        Les sous-objectifs sont :
                    </p>
                    <ul>
                        <li>créer des formations basées sur des degrés modèles pour des groupes d'étudiants ;</li>
                        <li>faire des bilans des séances de formation ;</li>
                        <li>informer l'étudiant de sa progression ;</li>
                        <li>superviser la formation d'un élève.</li>
                    </ul>
                    <p>
                        Ce traitement doit permettre d'assurer la qualité de la formation au contrôle, de tracer et faciliter la progression de l'étudiant.
                    </p>
                    <p>
                        Les tests de fin de degré ne sont pas inclus dans ce traitement.
                    </p>

                    <h3>Base légale</h3>
                    <p>
                        <a href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre2" target="_blank">Article 6</a> (e) du règlement général sur la protection des données - RGPD. Le traitement est nécessaire à l'exécution d'une mission d'intérêt public ou relevant de l'exercice de l'autorité publique dont est investi le responsable du traitement.
                    </p>

                    <h3>Données traitées</h3>
                    <p>
                        Les données traitées sont :
                    </p>
                    <ol class="spaced">
                        <li>des données d'identification et de gestion de l'utilisateur : identifiant informatique, numéro interne ENAC, nom, prénom, mail ENAC, rôle, photographie, organisation, affectation ;</li>
                        <li>des données relatives à une formation (promotion, élèves, degré, dates indicatives) ;</li>
                        <li>des données de suivi d'un élève liées à une séance :
                            <ul>
                                <li>Prise en compte par l'étudiant du suivi</li>
                                <li>Date</li>
                                <li>Validation par l'instructeur du suivi</li>
                                <li>Compétences évaluées</li>
                                <li>Commentaires (textuels, photos, dessins)</li>
                                <li>Position de l'élève</li>
                            </ul>
                        </li>
                    </ol>
                    <p>
                        Concernant les pseudo-pilotes, les données traitées sont le login qui est associé à leur nom et prénom et les commentaires qu’ils pourraient faire dans les logs de simulations.
                    </p>
                    <p>
                        L'ensemble de ces données sont à destination des organismes en charge de la formation (ENAC, éventuels clients) et de l'élève.
                    </p>

                    <h3>Source des données</h3>
                    <p>
                        Ces données sont recueillies directement via SOCRATES.
                    </p>

                    <h3>Caractère obligatoire du recueil des données</h3>
                    <p>
                        Le logiciel SOCRATES prévoit le recueil obligatoire des données qui sont nécessaires au traitement des données.
                    </p>

                    <h3>Prise de décision automatisée</h3>
                    <p>
                        Le traitement ne prévoit pas de
                        <a href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3" target="_blank">
                        prise de décision automatisée
                        </a>.
                    </p>

                    <h3>Personnes concernées</h3>
                    <p>
                        <u>
                            Catégories de personnes concernées dont les données à caractère personnel sont traitées
                        </u>
                    </p>
                    <p>
                        Les personnes concernées par le traitement sont les élèves et le personnel du département ATM de l’ENAC, ainsi que les pseudo-pilotes permettant le bon déroulement des simulations.
                    </p>
                    <p>
                        <u>
                            Catégories des personnes destinataires des données
                        </u>
                    </p>
                    <p>
                        Destinataires internes :
                    </p>
                    <ol>
                        <li>Instructeurs DER/ATM/FP</li>
                        <li>Inspecteurs des études DER/ATM/IEEE</li>
                        <li>Responsables de degré de DER/ATM/FP</li>
                        <li>Les membres du jury d’école si nécessaire</li>
                        <li>Responsable qualité DER/AT/FP</li>
                    </ol>
                    <p>
                        Destinataires externes :
                    </p>
                    <ol>
                        <li>DSNA (Chaque centre DSNA est destinataire des données relatives strictement aux élèves affectés chez lui)</li>
                        <li>Marine/Centre d’Entrainement et de Formation de l'Aéronautique Navale</li>
                        <li>Centre de contrôle Maastricht</li>
                    </ol>

                    <h3>Transferts des données hors UE</h3>
                    <p>
                        Aucun transfert de données hors de l'Union européenne n'est réalisé.
                    </p>

                    <h3>Durée de conservation des données</h3>
                    <p>
                        Les données sont conservées 7 années après la diplomation ou la fin de la formation ENAC.
                    </p>

                    <h3>Sécurité</h3>
                    <p>
                        Les mesures de sécurité sont mises en œuvre conformément à la politique de sécurité des systèmes d’information (PSSI) de l’ENAC, établies en conformité avec la PSSI de l’Etat.
                    </p>

                    <h3>Vos droits sur vos données</h3>
                    <p>
                        Vous pouvez accéder et obtenir une copie des données vous concernant, vous opposer au traitement de ces données, les faire rectifier ou les faire effacer. Vous disposez également d'un droit à la limitation du traitement de vos données.
                    </p>
                    <p>
                        <a href="https://www.cnil.fr/fr/mes-demarches/les-droits-pour-maitriser-vos-donnees-personnelles" target="_blank">
                        > Comprendre vos droits informatique et libertés
                        </a>
                    </p>

                    <h3>Exercer ses droits</h3>
                    <p>
                        La déléguée à la protection des données (DPO) de l’ENAC est votre interlocutrice pour toute demande d'exercice de vos droits sur ce traitement.
                    </p>
                    <ul>
                        <li>Contacter le DPO ENAC par voie électronique : <a href="mailto:dpo@enac.fr">dpo@enac.fr</a></li>
                        <li>Contacter le DPO ENAC par courrier postal : Secrétariat Général – Affaires Juridiques ,7 avenue Edouard Belin, CS 54005, 31055 Toulouse Cedex 4.</li>
                    </ul>

                    <h3>Réclamation (plainte) auprès de la CNIL</h3>
                    <p>
                        Si vous estimez, après nous avoir contacté, que vos droits sur vos données ne sont pas respectés, vous pouvez
                        <a href="https://connexion.services.cnil.fr/login/?nonce=_E681BECBF957603270A14D375606E07D&next=/idp/saml2/continue%3Fnonce%3D_E681BECBF957603270A14D375606E07D" target="_blank">
                        adresser une réclamation (plainte) à la CNIL
                        </a>.
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {

        computed: {

            breadcrumb() {
                return [{
                    name: this.$t('common.privacy'),
                }]
            }
        },
    }
</script>

<style scoped>
    .card {
        max-width: 1000px;
        margin: 0 auto;
    }
    p {
        font-weight: 400;
    }
</style>
